import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Report from '../components/Report';

let scrollToElement;
if (typeof window !== 'undefined') {
  scrollToElement = require('scroll-to-element'); // eslint-disable-line
}

class Reports extends React.Component {
  scrollToOldReports = () => {
    if (this.oldReportsTitle) {
      scrollToElement(this.oldReportsTitle, {
        offset: -50,
        ease: 'out-cube',
        duration: 1500,
      });
    }
  };
  render() {
    const reports = [
      ...this.props.reports
        .filter(
          report =>
            parseInt(moment().unix(), 10) <=
            parseInt(moment(report.validUntil, 'DD.MM.YYYY HH:mm:ss').unix(), 10),
        )
        .sort(
          (a, b) =>
            moment(b.validFrom, 'DD.MM.YYYY HH:mm:ss').unix() -
            moment(a.validFrom, 'DD.MM.YYYY HH:mm:ss').unix(),
        ),
    ];
    const reportsOld = [
      ...this.props.reports
        .filter(
          report =>
            parseInt(moment().unix(), 10) >
            parseInt(moment(report.validUntil, 'DD.MM.YYYY HH:mm:ss').unix(), 10),
        )
        .sort(
          (a, b) =>
            moment(b.validFrom, 'DD.MM.YYYY HH:mm:ss').unix() -
            moment(a.validFrom, 'DD.MM.YYYY HH:mm:ss').unix(),
        ),
    ];
    return (
      <div>
        {reports && reports.length > 0 ? (
          reports.map(report => <Report key={report.id} report={report} />)
        ) : (
          <div className="NoReportsContainer">
            <div className="NoReports-text">
              <h2>
                Aktuell gibt es keine <br /> Meldungen.
              </h2>
              <p>
                Der BIWAPP-Wächter hält Sie auf dem Laufenden, sobald es neue Meldungen für Ihren
                aktuellen Aufenthaltsort gibt. Sie können auch weitere Regionen über &quot;Meine
                Orte&quot; hinzufügen.
              </p>
            </div>
            {reportsOld &&
              reportsOld.length > 0 && (
                <button className="NoReports-scrollNotice" onClick={this.scrollToOldReports}>
                  <span className="NoReports-animation" />
                  Vergangene Meldungen
                </button>
              )}
          </div>
        )}

        {reportsOld &&
          reportsOld.length > 0 && [
            <h2
              key="title"
              ref={node => {
                this.oldReportsTitle = node;
              }}
            >
              Vergangene Meldungen
            </h2>,
            reportsOld.map(report => <Report key={report.id} report={report} read />),
          ]}
      </div>
    );
  }
}

Reports.propTypes = {
  reports: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  reports: state.reports.filter(report => !report.deleted && !report.isCatastrophy),
});

export default connect(mapStateToProps)(Reports);



// WEBPACK FOOTER //
// ./src/js/routes/Reports.js